import React from 'react';
import BlogSideNav from './BlogSideNav';
import BlogContent from './BlogContent';

const BlogItem = () => {
    return (
        <div className='flex flex-col items-center lg:flex-row lg:items-start lg:justify-between gap-x-12 gap-y-20'>
            <BlogContent />
            <BlogSideNav />
        </div>
    );
}

export default BlogItem;
